import React from "react";
import TablaSolicitudBeneficio from "js/components/TablaSolicitudCatalogoCodigos";

function SolicitudBeneficio(props) {
  return <TablaSolicitudBeneficio />;
}

export default SolicitudBeneficio;
